import { TFunction } from "i18next";
import { z } from "zod";
import { nullableNumber } from "../../../utils";

export const getFlowTestsInputDataFormSchema = (t: TFunction) => {
  const numberField = nullableNumber(t("generic.errors.invalid-number"));
  return z.object({
    constructionDetails: z.object({
      drainCasingRadius: numberField.optional(),
      firstDrainDepth: numberField.optional(),
      lastDrainDepth: numberField.optional(),
      sandBedHeight: numberField.optional(),
      entubationRadius: numberField.optional(),
      boreholeRadius: numberField.optional(),
    }),
  });
};

export type FlowTestsInputDataForm = z.infer<ReturnType<typeof getFlowTestsInputDataFormSchema>>;